module.exports = __webpack_public_path__ + "static/media/yellowfish1.ff1f1dce.png";